import React, { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import BillTable from "../BillTableView";
import { Container } from "react-bootstrap";

const Invoice = () => {
  // const [baseUrl, setBaseUrl] = useState('http://127.0.0.1:8000/api/');
  const [baseUrl, setBaseUrl] = useState("http://mol.evolve-demo.com/api/");
  const [pageComponent, setPageComponent] = useState("invoice");
  const [bookingNOList, setBookingNOList] = useState(undefined);
  const [invoiceNOList, setInvoiceNOList] = useState(undefined);
  const [bookingNOListAll, setBookingNOListAll] = useState(undefined);
  const [bookingNOListYear, setBookingNOListYear] = useState(undefined);
  const [isAllBooking, setIsAllBooking] = useState(false);
  const [bookingFilterdNOList, setBookingFilterdNOList] = useState(undefined);
  const [emptyBookingNUmber, setEmptyBookingNUmber] = useState(false);
  const [consigneeList, setConsigneeList] = useState(undefined);
  const [consignee, setConsignee] = useState(undefined);
  const [selectedTbaleRowID, setSelectedTbaleRowID] = useState("");
  const [currencyList, setCurrencyList] = useState(undefined);
  const [currCode, setCurrCode] = useState(false);
  const [currDesc, setCurrDesc] = useState(false);
  const [paytermList, setPaytermList] = useState(undefined);
  const [payterm, setPayterm] = useState("");
  const [bookindNo, setBookindNo] = useState("");
  const [iNVDate, setINVDate] = useState("");
  const [bookingNo, setBookingNo] = useState("");
  const [eXGRate, setEXGRate] = useState("");
  const [sVATNO, setsVATNO] = useState("");
  const [vATNO, setVATNO] = useState("");
  const [bLNO, setBLNO] = useState("");
  const [contNO, setContNO] = useState("");
  const [transactionClassList, setTransactionClassList] = useState(undefined);
  const [transactionClass, setTransactionClass] = useState("");
  const [transactionTypeList, setTransactionTypeList] = useState(undefined);
  const [transactionType, setTransactionType] = useState("");
  const [rateLIst, setRateLIst] = useState(undefined);
  const [rateCode, setRateCode] = useState("");
  const [rateDesc, setRateDesc] = useState("");
  const [exgRaterRow, setExgRaterRow] = useState("");
  const [volueRow, setVolueRow] = useState("");
  const [amountRow, setAmountRow] = useState("");
  const [remark, setRemark] = useState("");
  const [uSDAmount, setUSDAmount] = useState("");
  const [totalAmount, setTotalAmount] = useState("");
  const [contact, setContact] = useState("");
  const [selectedCurrType, setSelectedCurrType] = useState("");
  const [selectedPrintOption, setSelectedPrintOption] = useState("");

  const [tableItems, setTableItems] = useState([]);
  const [taxList, setTaxList] = useState(undefined);
  const [vatLIst, setVatLIst] = useState([]);
  const [nBTPrecentage, setNBTPrecentage] = useState(0);
  const [vatPrecentage, setVatPrecentage] = useState(0);

  const selectInvoive = (value) => {
    console.log(value);
    handleFunctionCall(value);
    // onhandleBookingNunber(value);
  };

  const handleFunctionCall = (value) => {
    if (value) {
      axios
        .get(`http://mol.evolve-demo.com/api/invoice/show/${value}`, {
          method: "GET",
          mode: "cors",
        })
        .then((response) => {
          console.log(
            response.data.invoice_detail.invoicewiserate_table_detail
          );
          setTableItems(
            response.data.invoice_detail.invoicewiserate_table_detail
          );
          setBookindNo(
            response.data.invoice_detail.invoice_header_detail[0].BookingNo
          );
          setINVDate(
            response.data.invoice_detail.invoice_header_detail[0].InvoiceDate
          );
          setCurrCode(
            response.data.invoice_detail.invoice_header_detail[0].CurrCode
          );
          setConsigneeList(response.data.invoice_detail.consignee_detail);
          setCurrDesc(
            response.data.invoice_detail.invoice_header_detail[0].CurrDesc
          );
          setEXGRate(
            response.data.invoice_detail.invoice_header_detail[0].ExRate
          );
          setPayterm(
            response.data.invoice_detail.invoice_header_detail[0].PAYTERM
          );
          setsVATNO(
            response.data.invoice_detail.invoice_header_detail[0].CustSVatNo
          );
          setVATNO(
            response.data.invoice_detail.invoice_header_detail[0].CustVATNo
          );
          setBLNO(response.data.invoice_detail.invoice_header_detail[0].BLNo);
          setContNO(
            response.data.invoice_detail.invoice_header_detail[0].ContainerNos
          );
          setTransactionClass(
            response.data.invoice_detail.invoice_header_detail[0]
              .TransactionClass
          );
          setRateCode(
            response.data.invoice_detail.invoice_header_detail[0].RateCode
          );
          setRateDesc(
            response.data.invoice_detail.invoice_header_detail[0].RateCode
          );
        })

        .catch((error) => {
          console.error(error);
        });
    }
  };

  const handleYearBooking = (event) => {
    setIsAllBooking(event.target.checked);
    if (event.target.checked == true) {
      setBookingNOList(bookingNOListAll !== undefined ? bookingNOListAll : "");
    }
    if (event.target.checked == false) {
      setBookingNOList(
        bookingNOListYear !== undefined ? bookingNOListYear : ""
      );
    }
  };

  const setCurrency = (value) => {
    setCurrCode(value);
    currencyList.forEach((CurrItem) => {
      if (CurrItem.CurrCode == value) {
        setCurrDesc(CurrItem.CurrDesc);
      }
    });
  };

  useEffect(() => {
    fetch(`${baseUrl}invoice/getInvoiceNo`)
      .then((response) => response.json())
      .then((data) => {
        setInvoiceNOList(data.InvoiceNo);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    fetch(`${baseUrl}tax/index`)
      .then((response) => response.json())
      .then((data) => {
        setTaxList(data.tax);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const setVAT = (event) => {
    if (event.target.checked == true) {
      setVatLIst([...vatLIst, event.target.id]);
    }

    if (event.target.checked == false) {
      const updatedArray = vatLIst.filter((item) => item !== event.target.id);
      setVatLIst(updatedArray);
    }
  };

  const passBookingNUM = (value) => {
    setBookindNo(value);
    console.log(value);
    if (value) {
      axios
        .get(`http://mol.evolve-demo.com/api/bookingcosting/show/${value}`, {
          method: "GET",
          mode: "cors",
        })
        .then((response) => {
          console.log(
            response.data.booking.booking_header_table_detail[0].CustName
          );
          setConsignee(
            response.data.booking.booking_header_table_detail[0].CustName
          );
          // setCost(response.data.booking.booking_detail[0][0].Cost);
          // selectCurruncy(response.data.booking[0].Currency);
        })

        .catch((error) => {
          console.error(error);
        });
    }
  };

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/getBookingNo`)
      .then((response) => response.json())
      .then((data) => {
        setBookingNOListAll(data.BookingNo.booking);
      })
      .catch((error) => {
        alert(error());
      });
  }, []);

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/indexYearFilter`)
      .then((response) => response.json())
      .then((data) => {
        setBookingNOListYear(data.invoice);
      })
      .catch((error) => {
        alert(error());
      });
  }, []);

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/getcurrency`)
      .then((response) => response.json())
      .then((data) => {
        setCurrencyList(data.currency);
      })
      .catch((error) => {
        alert(error());
      });
  }, []);

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/getcurrency`)
      .then((response) => response.json())
      .then((data) => {
        setCurrencyList(data.currency);
      })
      .catch((error) => {
        alert(error());
      });
  }, []);

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/gettransactionclass`)
      .then((response) => response.json())
      .then((data) => {
        setTransactionClassList(data.transclass);
      })
      .catch((error) => {
        alert(error());
      });
  }, []);

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/gettransactiontype`)
      .then((response) => response.json())
      .then((data) => {
        setTransactionTypeList(data.transtype);
      })
      .catch((error) => {
        alert(error());
      });
  }, []);

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/getrate`)
      .then((response) => response.json())
      .then((data) => {
        setRateLIst(data.rate);
      })
      .catch((error) => {
        alert(error());
      });
  }, []);

  const setTableValue = async () => {
    let Amount = 0;
    let totNBT = 0;
    let nbtPrec = 0;
    let vatPrec = 0;
    let percentage = 0;
    let vatAmount = 0;
    let nbtAmount = 0;

    vatLIst.forEach((vatItem) => {
      taxList.forEach((elementitem) => {
        if (elementitem.Tax == vatItem) {
          if (elementitem.TaxRate > 0) {
            percentage = elementitem.TaxRate / 100;
          } else {
            percentage = 0;
          }
          let tRate = elementitem.TaxRate;
          if (vatItem == "NBT") {
            nbtPrec = percentage;
            setNBTPrecentage(nbtPrec);
            nbtAmount = amountRow * vatPrec;
          } else if (vatItem == "VAT") {
            vatPrec = elementitem.TaxRate / 100;
            vatAmount = amountRow * vatPrec;
            setVatPrecentage(vatPrec);
          }
        }
      });
    });
    appndTableValue(vatAmount, vatPrec, nbtPrec, nbtAmount);
  };

  const setSelectVATTax = (value) => {
    if (value > 0) {
      var checkbox = document.getElementById("VAT");
      checkbox.checked = true;
    } else {
      var checkbox = document.getElementById("VAT");
      checkbox.checked = false;
    }
  };

  const setSelectNBTTax = (value) => {
    if (value > 0) {
      var checkbox = document.getElementById("NBT");
      checkbox.checked = true;
    } else {
      var checkbox = document.getElementById("NBT");
      checkbox.checked = false;
    }
  };

  const appndTableValue = async (vatAmount, vatPrec, nbtPrec, nbtAmount) => {
    const updateTableVal = {
      Rate: rateDesc,
      RateCode: rateCode,
      CurrCode: currCode,
      Currency: currDesc,
      ExRate: exgRaterRow,
      Volume: volueRow,
      Amount: amountRow,
      TotalAmount: amountRow * volueRow * exgRaterRow,
      Remark: remark,
      VATAmount: vatAmount,
      NBTPerc: nbtPrec,
      VATPerc: vatPrec,
      NBTAmount: nbtAmount,
    };
    const updateTableLIst = tableItems.concat(updateTableVal);
    setTableItems(updateTableLIst);
  };
  const calculateTotalAmount = () => {
    return tableItems.reduce(
      (total, tableItem) => total + tableItem.TotalAmount,
      0
    );
  };

  const RemoveSelectedDataRow = async () => {
    const updateTableLIst = tableItems.splice(selectedTbaleRowID);
    setTableItems(updateTableLIst);
  };

  const handlecurrOption = (event) => {
    setSelectedCurrType(event.target.value);
  };

  const handlePrintOption = (event) => {
    setSelectedPrintOption(event.target.value);
  };

  const selectRateChange = (event) => {
    const selectedValue = event.target.value;
    const selectedOption = rateLIst.find(
      (rateItem) => rateItem.RateCode === selectedValue
    );
    setRateCode(selectedValue);
    setRateDesc(selectedOption.RateDesc);
  };

  const saveINvoice = () => {
    const inputData = {
      BookingNo: bookindNo,
      CustCode: 8,
      CustName: "Test",
      InvoiceDate: iNVDate,
      BLNo: bLNO,
      AppStatus: 0, // 0=P , 1=A
      //AppStep: numeric,
      UserId: "8",
      EntryDate: iNVDate,
      InvoiceType: selectedCurrType,
      CurrCode: currCode,
      ExRate: exgRaterRow,
      PrintOption: selectedPrintOption,
      CustSVatNo: sVATNO,
      CustVATNo: vATNO,
      Contact: contact,
      CustAdd1: "",
      CustAdd2: "",
      CustAdd3: "",
      CustAdd4: "",
      ContainerNos: contNO,
      Payterm: payterm,
      TransactionClass: transactionClass,
      TransactionType: transactionType,
      InvoiceWiseRates: tableItems,
    };
    axios
      .post(`${baseUrl}${pageComponent}/store`, inputData, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((response) => {
        toast.success("Successfully Save Data ! ", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setTimeout(window.location.reload.bind(window.location), 2000);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  function setSelectedRow(rowid, row) {
    // console.log(rowid);
    console.log(row);
    setVolueRow(row.Volume);
    setAmountRow(row.Amount);
    setTotalAmount(row.TotalAmount);
    setVolueRow(row.Volume);
    setRemark(row.remark);
    setSelectVATTax(row.VATPercentage);
    setSelectNBTTax(row.NBTPrecentage);
    setSelectedTbaleRowID(rowid);
  }

  const headercolumns = [
    "Rate",
    "Currency",
    "EX Rate",
    "Volume",
    "Amount",
    "Total Amount",
    "Remark",
    "NBT Percentage",
    "VAT Percentage",
    "NBT Amount",
    "VAT Amount",
  ];
  const columns = [
    "Rate",
    "Currency",
    "ExRate",
    "Volume",
    "Amount",
    "TotalAmount",
    "Remark",
    "NBTPerc",
    "VATPerc",
    "NBTAmount",
    "VATAmount",
  ];

  return (
    <Container>
      <ToastContainer autoClose={2000} />
      <Row>
        <Col>
          <Form className="mt-4 bottom-border pb-3">
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Invoice No</Form.Label>
                  <Form.Select
                    aria-label=""
                    onChange={(e) => selectInvoive(e.target.value)}
                  >
                    <option value=""></option>

                    {invoiceNOList !== undefined
                      ? invoiceNOList.map((invoiceItem, id) => (
                          <option value={invoiceItem.id} key={id}>
                            {invoiceItem.InvNo}
                          </option>
                        ))
                      : ""}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Booking No</Form.Label>
                  <Form.Select
                    aria-label="Default select"
                    className={emptyBookingNUmber == true ? "border-red2" : ""}
                    value={bookindNo}
                    onChange={(e) => passBookingNUM(e.target.value)}
                  >
                    {bookingNOList !== undefined
                      ? bookingNOList.map((booking) => (
                          <option value={booking.id} key={booking.id}>
                            {booking.BookingNo}
                          </option>
                        ))
                      : ""}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Inv Date</Form.Label>
                  <Form.Control
                    type="date"
                    placeholder=""
                    autoComplete="off"
                    name="date"
                    value={iNVDate}
                    onChange={(e) => setINVDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Consignee</Form.Label>
                  <Form.Select aria-label="">
                    {consignee ? (
                      <option>{consignee ? consignee : ""}</option>
                    ) : consigneeList ? (
                      consigneeList[0].Consignee_1 ? (
                        <option value={consigneeList[0].Consignee_1}>
                          {consigneeList[0].Consignee_1}
                        </option>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}

                    {consigneeList ? (
                      consigneeList[0].Consignee_2 ? (
                        <option value={consigneeList[0].Consignee_2}>
                          {consigneeList[0].Consignee_2}
                        </option>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}

                    {consigneeList ? (
                      consigneeList[0].Consignee_3 ? (
                        <option value={consigneeList[0].Consignee_3}>
                          {consigneeList[0].Consignee_3}
                        </option>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}

                    {consigneeList ? (
                      consigneeList[0].Consignee_4 ? (
                        <option value={consigneeList[0].Consignee_4}>
                          {consigneeList[0].Consignee_4}
                        </option>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3 ">
                  <Form.Check
                    type="checkbox"
                    label="All Booling"
                    onChange={handleYearBooking}
                    checked={isAllBooking}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Label>Active</Form.Label>
              </Col>
              <Col></Col>
              <Col></Col>
            </Row>
            <Row>
              <Col>
                <Form.Label>Invoice Type Customer</Form.Label>
                <div>
                  <input
                    type="radio"
                    value="L"
                    name="currtype"
                    onChange={handlecurrOption}
                  />{" "}
                  <Form.Label>Local</Form.Label>
                  <input
                    type="radio"
                    value="F"
                    className="ms-4"
                    name="currtype"
                    onChange={handlecurrOption}
                  />{" "}
                  <Form.Label>Foregin</Form.Label>
                </div>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Currency {currCode} {currDesc}
                  </Form.Label>
                  <Form.Select
                    aria-label="Default select"
                    value={currCode}
                    onChange={(e) => setCurrency(e.target.value)}
                  >
                    currCode ?<option value={currCode}>{currDesc}</option>: ''
                    {currencyList !== undefined
                      ? currencyList.map((curritem, id) => (
                          <option value={curritem.CurrCode} key={id}>
                            {curritem.CurrDesc}
                          </option>
                        ))
                      : ""}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Exg Rate </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    autoComplete="off"
                    name="exgrate"
                    value={eXGRate}
                    onChange={(e) => setEXGRate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Payment Term {payterm}</Form.Label>
                  <Form.Select
                    aria-label=""
                    value={payterm}
                    onChange={(e) => setPayterm(e.target.value)}
                  >
                    payterm ? <option value={payterm}>{payterm}</option> :
                    <option value="0001">30 Net </option>
                    <option value="0002">IMMEDIATE</option>
                    <option value="0003">7 Net</option>
                    <option value="0004">10 Net</option>
                    <option value="0005">60 Net</option>
                    <option value="0006">15 Net</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Label>Print Option Customer</Form.Label>
                <div>
                  <input
                    type="radio"
                    value="normal"
                    name="printtype"
                    onChange={handlePrintOption}
                  />{" "}
                  <Form.Label>Normal</Form.Label>
                  <input
                    type="radio"
                    value="svat"
                    name="printtype"
                    className="ms-4"
                    onChange={handlePrintOption}
                  />{" "}
                  <Form.Label>S Vat</Form.Label>
                </div>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>S Vat No</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    autoComplete="off"
                    name="svatno"
                    value={sVATNO}
                    onChange={(e) => setsVATNO(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Vat No</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    autoComplete="off"
                    name="vatno"
                    value={vATNO}
                    onChange={(e) => setVATNO(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col></Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>BL Nos {bLNO}</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    autoComplete="off"
                    value={bLNO}
                    onChange={(e) => setBLNO(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Conta Nos {contNO}</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    autoComplete="off"
                    name="Hbl"
                    value={contNO}
                    onChange={(e) => setContNO(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Transaction Class {transactionClass}</Form.Label>
                  <Form.Select
                    aria-label="Default select"
                    value={transactionClass}
                    onChange={(e) => setTransactionClass(e.target.value)}
                  >
                    transactionClass ?
                    <option value={transactionClass}>{transactionClass}</option>
                    : ''
                    {transactionClassList !== undefined
                      ? transactionClassList.map((transactionClass, id) => (
                          <option
                            value={transactionClass.TransactionClass}
                            key={id}
                          >
                            {transactionClass.TransactionClass}
                          </option>
                        ))
                      : ""}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Transaction Type {transactionType} </Form.Label>
                  <Form.Select
                    aria-label="Default select"
                    value={transactionType}
                    onChange={(e) => setTransactionType(e.target.value)}
                  >
                    transactionType ?
                    <option value={transactionType}>{transactionType}</option>:
                    ''
                    {transactionTypeList !== undefined
                      ? transactionTypeList.map((transactionType, id) => (
                          <option
                            value={transactionType.TransactionType}
                            key={id}
                          >
                            {transactionType.TransactionType}
                          </option>
                        ))
                      : ""}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Rate {rateCode}</Form.Label>
                  <Form.Select
                    aria-label="Default select"
                    value={rateCode}
                    onChange={selectRateChange}
                  >
                    <option value=""></option>
                    {rateLIst !== undefined
                      ? rateLIst.map((rateItem, id) => (
                          <option value={rateItem.RateCode} key={id}>
                            {rateItem.RateDesc}
                          </option>
                        ))
                      : ""}
                  </Form.Select>
                </Form.Group>
              </Col>

              {taxList != undefined
                ? taxList.map((taxItem) =>
                    taxItem.Active == 1 ? (
                      <Col key={taxItem.id}>
                        <Form.Group className="mb-3" controlId="">
                          <Form.Check
                            type="checkbox"
                            label={taxItem.Tax}
                            id={taxItem.Tax}
                            onChange={setVAT}
                          />
                        </Form.Group>
                      </Col>
                    ) : (
                      ""
                    )
                  )
                : ""}
              <Col>
                <Col className="text-center mt-4">
                  <Button
                    className="ms-3"
                    variant="primary"
                    onClick={setTableValue}
                  >
                    ADD
                  </Button>
                  <Button
                    className="ms-3"
                    variant="primary"
                    onClick={RemoveSelectedDataRow}
                  >
                    Delete
                  </Button>
                </Col>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Currency {currCode} {currDesc}
                  </Form.Label>
                  <Form.Select
                    aria-label="Default select"
                    value={currCode}
                    onChange={(e) => setCurrency(e.target.value)}
                  >
                    currCode ?<option value={currCode}>{currDesc}</option>: ''
                    {currencyList !== undefined
                      ? currencyList.map((curritem, id) => (
                          <option value={curritem.CurrCode} key={id}>
                            {curritem.CurrDesc}
                          </option>
                        ))
                      : ""}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Exg Rate</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    autoComplete="off"
                    name="exg_rate"
                    value={exgRaterRow}
                    onChange={(e) => setExgRaterRow(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Volume {volueRow}</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    autoComplete="off"
                    name="VolumeRow"
                    value={volueRow}
                    onChange={(e) => setVolueRow(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Amount</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    autoComplete="off"
                    name=""
                    value={amountRow}
                    onChange={(e) => setAmountRow(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Remark </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    autoComplete="off"
                    name="Hbl"
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mt-4">
              <Col>
                <BillTable
                  data={tableItems}
                  columns={columns}
                  headercolumns={headercolumns}
                  setSelectedRow={setSelectedRow}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Total USD Amount</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    autoComplete="off"
                    name="totAmountUSD"
                    value={uSDAmount}
                    onChange={(e) => setUSDAmount(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Total Amount</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    autoComplete="off"
                    name="TotalAmount"
                    value={calculateTotalAmount()}
                    onChange={(e) => setTotalAmount(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Contact</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    autoComplete="off"
                    name="Contact"
                    value={contact}
                    onChange={(e) => setContact(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
      <Row className="text-center mt-4">
        <Col className="text-end">
          <Button className="ms-3" variant="primary" onClick={saveINvoice}>
            Save
          </Button>
          <Button className="ms-3" variant="primary">
            New
          </Button>
          <Button className="ms-3" variant="primary">
            Credit Note
          </Button>
          <Button className="ms-3" variant="primary">
            Print
          </Button>
          <Button className="ms-3" variant="primary" type="submit">
            Cancel
          </Button>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          {/* <TableView data={data} columns={columns} setSelectedRow={setSelectedRow} /> */}
        </Col>
      </Row>
    </Container>
  );
};

export default Invoice;
